
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/legal/guild/membership",
      function () {
        return require("private-next-pages/[locale]/legal/guild/membership/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/legal/guild/membership"])
      });
    }
  